import { remoteRegions } from "data/remoteRegions/remoteRegions";

export const getRegionById = (regionId: string) =>
  remoteRegions.find((r) => r.id === regionId);
